<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-08-08 16:46:34
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-03-09 14:26:10
-->
<template>
  <input type="file"
         ref="uploadInput"
         value=""
         style="width: 100%;position:absolute;height:100%;top:0;left:-150px;opacity: 0;z-index:5;cursor:pointer;padding-right:150px;box-sizing: content-box;"
         :multiple='multiple'
         :accept="accept"
         @change="fileChange">
</template>

<script>
/**
 * accept input         接受文件类型
 * uploadFileType       验证类型
 * @changeimgSrc        文件改变事件
 */
import { get_list } from '@/service/api/func_module'
import http from '@/service/httpConfig.js'
import {
  addFile, addResultFile, deleteFile, deleteResultFile
} from '@/service/api/fileManagements.js'
export default {
  components: {},
  props: {
    accept: {
      type: String,
      default: 'image/*'
    },
    uploadFileType: {},
    multiple: {
      type: Boolean,
      default: false
    }
    // imgSrc: {},
  },
  // model: {
  //   prop: 'imgSrc',
  //   event: 'changeimgSrc'
  // },
  data () {
    return {
    };
  },
  computed: {},
  created () { },
  watch: {},
  async mounted () {
    let _this = this;
    var dropbox = this.$refs.uploadInput ? this.$refs.uploadInput : ''
    if (dropbox == '') return
    dropbox.addEventListener("drop", this.enentDrop, false)
    dropbox.addEventListener("dragleave", function (e) {
      e.stopPropagation();
      e.preventDefault();
      // _this.borderhover = false;
    })
    dropbox.addEventListener("dragenter", function (e) {
      e.stopPropagation();
      e.preventDefault();
      // _this.borderhover = true;
    })
    dropbox.addEventListener("dragover", function (e) {
      e.stopPropagation();
      e.preventDefault();
      // _this.borderhover = true
    })
  },
  methods: {
    fileChange (e) {
      if (!e.target.files.length > 0) return
      if (!this.validateUploadFileType(e.target.files)) return this.$Message({ text: this.$t('message_upload_image_format_error'), color: 'rgba(0,0,0,0.78)' })
      this.$emit('changeimgSrc', e.target.files)
    },
    enentDrop: function (e) {
      this.borderhover = false
      e.stopPropagation();
      e.preventDefault();  //必填字段
      // console.log(e.dataTransfer.files);
      if (!e.dataTransfer.files.length > 0) return
      if (!this.validateUploadFileType(e.dataTransfer.files)) return
      this.$emit('changeimgSrc', e.dataTransfer.files)
    },
    validateUploadFileType (curFileType) {  // 验证文件类型
      return this.uploadFileType.test(curFileType[0].name)
    },
  },
};
</script>

<style scoped>
</style>
